import auth from './auth';
import marketing from './marketing';

export default Object.assign({}, auth, marketing);
